import { ProjectCard } from "@/components/ProjectCard";
import { TypoP } from "@/components/ui/typography";
import { Python } from "developer-icons";
import type { DeveloperIconProps } from "developer-icons/dist/icon";
import { BrainCircuit, Database, Link2 } from "lucide-react";

// developer-icons has no LangChain / Qdrant / local-LLM logos, so these wrap
// lucide glyphs behind the same props signature as the developer-icons components.
const LangChainIcon = ({ className }: DeveloperIconProps) => <Link2 className={className}><title>LangChain</title></Link2>;
const QdrantIcon = ({ className }: DeveloperIconProps) => <Database className={className}><title>Qdrant</title></Database>;
const LocalLLMIcon = ({ className }: DeveloperIconProps) => <BrainCircuit className={className}><title>Local LLM</title></BrainCircuit>;

export function LLMagistratCard(props: React.HTMLAttributes<HTMLDivElement>) {
    return (
        <ProjectCard
            {...props}
            className="w-full"
            title="LLMagistrat"
            links={[]}
            body={
                <TypoP className="text-sm">
                    More to come very soon ...
                </TypoP>
            }
            techStack={[Python, LangChainIcon, QdrantIcon, LocalLLMIcon]}
            infoList={[]}
            imageUrl={undefined}
        />
    );
}
